import { SongResponseDTO } from '@core/api/dtos/response/song/song'
import { Song } from '@core/api/entities/song/song'

import { MetadataMapper } from './metadataMapper'
import { TrackVariableMapper } from './trackVariableMapper'

export class SongMapper {
	static toEntity(data: SongResponseDTO): Song {
		return new Song({
			id: data.id,
			path: data.path,
			pathNormalized: data.path_normalized,
			size: data.size,

			metadata: MetadataMapper.toEntity(data.metadata),
			trackVariableMetadata: data.track_variable_metadata?.data
				? TrackVariableMapper.toEntities(data.track_variable_metadata.data)
				: undefined,
		})
	}

	static toEntities(data: SongResponseDTO[]): Song[] {
		return data.map((item) => this.toEntity(item))
	}
}
